<template>
  <b-container>
    <b-col class="mt-2">
      <h2>
        {{ $t(title) }}
      </h2>
      <div style="margin-top: 20px; margin-bottom: 20px">
        <b-row>
          <b-col cols="12">
            <b-input-group>
              <b-input-group-prepend is-text>
                <icon class="fa-icon-nuevo" name="search"/>
              </b-input-group-prepend>
              <b-form-input
                :placeholder="$t('label_evaluation_search_placeholder')"
                v-model="searchBarText"
                @input="waitAndSearch()"
              />
            </b-input-group>
          </b-col>
        </b-row>
      </div>
      <div class="cardContainer">
        <div v-if="!isReportsList && !isOrganizationList && !isPNUDADMIN">
          <b-container style="margin-bottom: 10px">
            <b-row class="text-center">
              <b-col>
                <b-button
                  v-if="getUserAccount.numberOfCompanies > 0"
                  variant="primary"
                  @click="
                    openModal(
                      'label_evaluation_administrator_evaluations_createSingleOrganization',
                      'label_evaluation_create_button',
                      null,
                      'single'
                    )
                  "
                >
                  {{$t("label_evaluation_administrator_evaluations_createSingleOrganization")}}
                </b-button>
              </b-col>
              <b-col>
                <b-button
                  v-if="getUserAccount.numberOfCompanies > 0"
                  variant="primary"
                  @click="
                    openModal(
                      'label_evaluation_administrator_model_new',
                      'label_evaluation_create_button',
                      null,
                      'multi'
                    )
                  "
                >
                  {{$t("label_evaluation_administrator_evaluations_createEvaluationForGroup")}}
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div>
          <b-row>
            <b-col cols="10"></b-col>
            <b-col style="text-align: right" cols="2">
              <div>
                <b-dropdown
                  id="dropdown-1"
                  :text="$t('label_evaluation_administrator_fields')"
                  class="m-md-2"
                  variant="borderless"
                  >
                    <b-dropdown-form>
                      <b-form-group>
                        <b-form-checkbox-group
                          id="checkbox-group-1"
                          v-model="selected"
                          :options="selectableFields"
                          value-field="name"
                          text-field="label"
                          stacked
                        ></b-form-checkbox-group>
                      </b-form-group>
                    </b-dropdown-form>
                </b-dropdown>
              </div>
            </b-col>
          </b-row>
          <b-table
            id="my-table"
            hover
            :items="evaluationsList"
            :per-page="perPage"
            :current-page="1"
            :fields="selectedFields"
            small
          >
            <template #head(_id)="">
              <span />
            </template>
            <template #head(snapshotId)="" />
            <template #head(evaluation_administrator_evaluations_selectTag)="">
              {{ $t("label_evaluation_administrator_evaluations_selectTag") }}
            </template>
            <template
              #head(evaluation_administrator_evaluations_evaluationName)=""
            >
              <span :class="verifyTitleSelection('evaluation_administrator_evaluations_evaluationName')">{{ $t("label_evaluation_administrator_evaluations_evaluationName") }}</span>
              <i class="bi bi-arrow-up icon-button"
                :class="verifyButtonSelection('evaluation_administrator_evaluations_evaluationName', 1)"
                @click="changeOrder('evaluation_administrator_evaluations_evaluationName', 1)"
              ></i>
              <i class="bi bi-arrow-down icon-button"
                :class="verifyButtonSelection('evaluation_administrator_evaluations_evaluationName', -1)"
                @click="changeOrder('evaluation_administrator_evaluations_evaluationName', -1)"
              ></i>
            </template>
            <template
              v-for="field in selectableFields"
              v-slot:[`head(${field.name})`]=""
            >
              <div style="    white-space: nowrap;">
                <span :class="verifyTitleSelection(field.name)">{{ $t(field.label) }}</span>

              <i class="bi bi-arrow-up icon-button"
                :class="verifyButtonSelection(field.name, 1)"
                @click="changeOrder(field.name, 1)"
              ></i>
              <i class="bi bi-arrow-down icon-button"
                :class="verifyButtonSelection(field.name, -1)"
                @click="changeOrder(field.name, -1)"
              ></i>
              </div>
            </template>
            <template #cell(snapshotId)="" />
            <template
              #cell(evaluation_administrator_evaluations_selectTag)="data"
            >
              <span v-if="data.unformatted">
                <div @click="openEvaluation(data.item._id)">
                  {{ data.unformatted.name }}
                </div>
              </span>
            </template>
            <template
              #cell(evaluation_administrator_evaluations_evaluationName)="data"
            >
              <div class="mouseOverItem" style='width: 200px' @click="openEvaluation(data.item._id)">
                {{data.item.evaluation_administrator_evaluations_evaluationName}}
              </div>
            </template>

            <template
              v-for="field in selectableFields"
              v-slot:[`cell(${field.name})`]="data"
            >
              <div class="mouseOverItem" style='max-width: 200px' @click="openEvaluation(data.item._id)">
                <div v-if="field.name != 'evaluation_administrator_evaluations_selectTag' && field.name !== 'businessName'">
                  {{data.item[field.name]}}
                </div>
                <div v-else>
                  <div v-if="data.item[field.name]">{{data.item[field.name].name}}</div>
                </div>
              </div>
            </template>

            <template
              #cell(country)="data"
            >
              <div class="mouseOverItem" style='width: 200px' @click="openEvaluation(data.item._id)">
                {{$t(data.item.country)}}
              </div>
            </template>

              <template #cell(_id)="data">
                <b-row v-if="!isReportsList">

                  <b-col
                    v-if="canEdit(data.item)"
                    style="cursor: pointer"
                    @click="
                      openModal(
                        'label_evaluation_edit_button',
                        'label_evaluation_save_button',
                        data.item._id
                      )
                    "
                  >
                    <img
                      src="../../../../assets/images/edit_icon.svg"
                      style="width: 20px; height: 20px"
                    />
                  </b-col>
                  <b-col style="cursor: pointer" @click="data.toggleDetails">
                    <img
                      src="../../../../assets/images/showInfo_icon.svg"
                      style="width: 20px; height: 20px"
                    />
                  </b-col>
                </b-row>
              </template>
            <template #row-details="row">
              <b-card>
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right">
                    <b>{{
                      $t("label_evaluation_administrator_details_model_name")
                    }}</b>
                  </b-col>
                  <b-col v-if="row.item.evaluation_administrator_model_name">
                    {{ row.item.evaluation_administrator_model_name }}
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right">
                    <b>{{
                      $t("label_evaluation_administrator_evaluations_selectTag")
                    }}:</b>
                  </b-col>
                  <b-col v-if="row.item.evaluation_administrator_evaluations_selectTag">
                    {{ row.item.evaluation_administrator_evaluations_selectTag.name }}
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right">
                    <b>{{$t("label_evaluation_administrator_details_startDateLastUpdated")}}</b>
                  </b-col>
                  <b-col>{{
                    row.item.evaluation.evaluation_last_updated
                  }}</b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right">
                    <b>{{$t("label_evaluation_administrator_details_evaluators")}}</b>
                  </b-col>
                  <b-col>
                    <div
                      v-for="(evaluator, indexEval) of row.item
                        .evaluation_administrator_evaluations_assignEvaluator"
                      :key="indexEval"
                    >
                      {{ evaluator.name }} {{ evaluator.lastName }}
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right">
                    <b>{{$t("label_evaluation_administrator_details_evaluatedOrganizations")}}</b>
                  </b-col>
                  <b-col>
                    <div
                      v-for="(business, indexBss) of row.item.businessName"
                      :key="indexBss"
                    >
                      {{ business.selfAssessment_general_business_companyName }}
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right">
                    <b>{{
                      $t(
                        "label_evaluation_administrator_details_evaluationName"
                      )
                    }}</b>
                  </b-col>
                  <b-col>{{
                    row.item.evaluation_administrator_evaluations_evaluationName
                  }}</b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right">
                    <b>{{
                      $t("label_evaluation_administrator_details_status")
                    }}</b>
                  </b-col>
                  <b-col>{{ row.item.evaluation.evaluation_status }}</b-col>
                </b-row>
                <b-row>
                  <b-col class="text-right">
                <b-btn variant="primary" size="sm" @click="row.toggleDetails">
                  {{ $t("label_evaluation_administrator_hideDetails_button") }}
                </b-btn>
                  </b-col>
                </b-row>
              </b-card>
            </template>
          </b-table>

          <create-evaluation-modal
            :showModal.sync="showModal"
            :modalInfo="modalInfo"
            :type.sync="type"
            :id.sync="id"
            @refreseh="getPaginated()"
          />

          <p class="mt-3">{{$t('label_current_page')}}: {{ currentPage }}</p>
          <b-row align-h="between">
            <b-col>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
                class="customPagination"
                @input="getPaginated()"
              />
            </b-col>
            <b-col>
              <b-form-group cols="4">
                <b-form-select
                  v-model="perPage"
                  @change="getPaginated()"
                >
                  <option :key="index" v-for="(option, index) in displayingNumberOfModelsOptions" :value="option.value">
                    {{ $t(option.label) }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-col>
    <div>

    </div>
  </b-container>
</template>
<script >
import { mapGetters } from "vuex";
import { axiosCall } from "../../../../utils/axiosCall";
import CreateEvaluationModal from "./CreateEvaluationModal";

export default {
  name: "EvaluationsList",
  components: {CreateEvaluationModal },
  data() {
    return {
      type: null,
      perPage: 10,
      selectableFields: [],
      selected: ["evaluation_administrator_model_name", "country", "createdAt"],
      currentPage: 1,
      showModal: false,
      evaluationsList: [],
      success: true,
      business: [],
      allBusiness: [],
      evaluations: [],
      modalInfo: { title: "", actionName: "", type: "", currentObject: {} },
      type: null,
      id: null,
      sortBy: 'evaluation_administrator_evaluations_evaluationName',
      order: 1,
      searchBarText: '',
      searchedText: '',
      rows: 0,
      displayingNumberOfModelsOptions: [
        {label: "optionList_evaluation_pagination_5", value: 5},
        {label: "optionList_evaluation_pagination_10", value: 10},
        {label: "optionList_evaluation_pagination_50", value: 50},
        {label: "optionList_evaluation_pagination_100", value: 100}
      ],
    };
  },
  props:{
    isReportsList:{
      type: Boolean,
      default: false,
    },
    isOrganizationList:{
      type: Boolean,
      default: false,
    },
    title:{
      type: String,
      default: "",
    },
  },
  created: async function() {
    this.loadSelectableFields()
    this.getPaginated();
    await this.$store.dispatch("COUNTRIES_GET")
  },
  computed: {
    ...mapGetters([
      "getUserAccountBusinesses",
      "getUserAccount",
      "getLang",
      "getCountries",
      ]),
    selectedFields(){
      var fields = []
      var optionalFields = [
      "businessOrTagName",
      "evaluation_administrator_model_name",
      "country",
      "createdAt"
      ]
      fields.push("evaluation_administrator_evaluations_evaluationName")
      for(var i = 0; i < optionalFields.length; i++){
        let sel = this.selected.find((element)=>           element === optionalFields[i])
        if(sel) {
          fields.push(optionalFields[i])
        }
      }
      fields.push("_id")
      return fields
    },
  },
  watch: {
    getLang: function(){
      this.loadSelectableFields()
    }
  },
  methods: {
    getCountryFromId(id){
        var temp
        this.getCountries.forEach(item => {
            if(item.id === id)
                temp = item.country
        })
        return temp
    },
    loadSelectableFields(){
      this.selectableFields = [
        {
          name: "businessOrTagName",
          label: this.$t("label_evaluation_administrator_organizationName"),
        },
        {
          name: "evaluation_administrator_model_name",
          label: this.$t("label_evaluation_administrator_model_name"),
        },
        {
          name: "country",
          label: this.$t("label_evaluation_administrator_evaluations_country")
        },
        {
          name: "createdAt",
          label: this.$t("label_evaluation_administrator_evaluations_creationDate"),
        }
      ]
    },
    openModal(title, actionName, id, type){
      this.type = type;
      this.modalInfo.title = title;
      this.modalInfo.actionName = actionName;
      this.id = id
      this.showModal = true;
    },
    verifyButtonSelection(criteria, order){
      if(this.sortBy === criteria && this.order === order) {
        return 'selected'
      }
      else {
        return ''
      }
    },
    verifyTitleSelection(criteria) {
      if (this.sortBy === criteria) {
        return 'selected-title';
      } else {
        return ''
      }
    },
    changeOrder(criteria, order) {
      this.sortBy =criteria
      this.order = order
      this.currentPage = 1
      this.getPaginated()
    },
    waitAndSearch: function () {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.searchText();
      }, 500);
    },
    searchText(){
      this.searchedText = this.searchBarText
      this.currentPage = 1
      this.getPaginated()
    },
    canEdit(evaluation) {
      const userBusiness = (this.getUserAccountBusinesses || []).map(
        (ab) => ab.id
      );
      const evaluationBusiness = evaluation.businessId;
      const found = evaluationBusiness.some((r) => userBusiness.includes(r));
      return found;
    },
    forceUp() {
      this.$forceUpdate();
    },
    changeSelectedMulti() {},
    userName(user) {
      return user.name + " " + user.lastName;
    },
    openEvaluation(evaluationId){
      if(this.isReportsList) {
        this.$router.push("/evaluation/report/" + evaluationId);
      }else if(this.isOrganizationList){
        this.$router.push("/evaluation/Organization/" + evaluationId);
      }
      else {
        this.$router.push("/evaluation/evaluate/" + evaluationId);
      }
    },

    getPaginated(){
      var data = {
        page: this.currentPage,
        pageSize: this.perPage,
        sortBy: this.sortBy,
        order: this.order,
        searchText: this.searchedText,
      };
      if(this.sortBy === "country"){
        data.sortBy = "countryAbbreviated"
      }
      axiosCall({ url: "Evaluations/getPaginated?showSpinner=true", method: "POST", data })
        .then((response) => {
          this.evaluationsList = response.data.evaluations;
          this.evaluationsList.map((evaluation) => {
            if (!evaluation.evaluation_administrator_evaluations_selectTag) {
              // eslint-disable-next-line camelcase
              evaluation.evaluation_administrator_evaluations_selectTag = null;
            }
          });
          this.rows = response.data.totalEvaluationsFiltered
          this.$root.$emit('bv::refresh::table', 'my-table')
        })
        .catch(() => {
        })
        .catch(() => {
        });
      },
    },
  };
</script>

<style src="../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css" ></style >
<style lang="scss" scoped >

@import "../../../../assets/css/variables";

.cardContainer {
  border: 1px solid #000000;
  width: 100%;
  padding: 30px 40px;
}
.cardContainer h5 {
  text-align: center;
  width: 100%;
}
h2 {
  color: black;
  margin: 1em 0;
}
legend {
  font-weight: bold;
  font-size: 14px !important;
}
.businessName {
  font-size: 12px !important;
  text-align: left;
}
h4 {
  font-size: 1.3rem;
  text-transform: uppercase;
}
.mouseOverItem:hover {
  cursor: pointer;
  text-decoration: underline;
}
.icon-button {
  cursor: pointer;
  &.selected {
    color: $primary-color;
    &:before {
      -webkit-text-stroke: 1px;
    }
  }
}
.selected-title {
  color: $primary-color;
}
</style>
<style lang="scss">
.customPagination  li  a {
  color: #00a29c !important;
}
.customPagination  li.active  a,
.customPagination  li  a:hover {
  background-color: #00a29c !important;
  border-color: #00a29c !important;
  color: #ffffff !important;
}

</style>
